// extracted by mini-css-extract-plugin
export default {"readyArea":"ReadyArea_readyArea__bzqlv","startButton":"ReadyArea_startButton__8Br0G"};